module.exports = __webpack_public_path__ + "static/media/triangle180.42187df0.svg";